export default "__VITE_ASSET__BTFzT9aJ__"